import React, { useState, useRef} from 'react';
import { Skeleton, Stack, Typography} from '@mui/material';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';
import { FieldComponent } from '../../types/FieldComponent';
import { TimeFilter } from '../Table/filters/TimeFilter';
import Box from '@mui/material/Box';
import { SPTextField } from '../Table/fields/SPTextField';
import { SPRichTextField } from '../Table/fields/SPRichTextField';
import { SPBooleanField } from '../Table/fields/SPBooleanField';
import { SPNumberField } from '../Table/fields/SPNumberField';
import {enumItems} from "../../schema/enumItems";
import {CustomFieldSPSelectField} from "../Table/fields/CustomFiledSPSelectField";

type Props<T extends Entity> = {
    schema: SchemaWithClient<T>;
};
export const FullWidthCustomFields: FieldComponent<any, any> = ({
                                                           onChange,
                                                           isActive,
                                                           value,
                                                           defaultValue,
                                                           hasTooltip,
                                                           disabled,
                                                           mui,
                                                           column,
                                                           allValue,
                                                       }) => {
    const [properties, setProperties] = useState<any>(undefined);
    const [loading, setLoading] = useState<any>(false);
    const ref = useRef();

    const customFieldsRef:any = useRef(null);

   /* useEffect(()=>{

        if (!defaultValue.length){

            if (customFieldsRef?.current){
                const closestParent = customFieldsRef.current?.closest('.MuiStack-root');
                const oneMoreLevelUp = closestParent?.parentElement;
                const oneMoreLevelUp1 = oneMoreLevelUp?.parentElement;

                oneMoreLevelUp1.style.display = 'none';
            }

        }


    },[])*/

    return (
      <>
          {loading ? (
            <>
                <Skeleton variant="rectangular" width={'100%'} height={30} />
            </>
          ) : (
            <>
                <Stack direction={'column'} ref={customFieldsRef} gap={0}>
                    <hr/>
                    {defaultValue.map((item: any, index: number) => {
                        return (
                          <>
                              <Stack
                                key={index}
                                direction={'column'}
                                gap={1}
                                alignContent={'center'}
                                sx={{
                                    width: '100%',
                                    marginY: '2px',
                                }}
                              >
                                  <Box
                                    sx={{
                                        flexShrink: 0,
                                        width: '150px',
                                    }}
                                  >
                                      <Typography
                                        variant="subtitle1"
                                        fontWeight={'bold'}
                                        sx={{
                                            marginTop: '9px',
                                        }}
                                      >
                                          <span>{item?.name}</span>
                                      </Typography>
                                  </Box>



                                  <Stack
                                    sx={{
                                        width: '100%',
                                        '& .rdw-option-wrapper': {
                                            margin: '0px'
                                        }
                                    }}
                                    alignItems={'flex-start'}
                                  >
                                      {item.type === 'string' && (
                                        <SPTextField
                                          defaultValue={allValue[`${item?.column_name}`]}
                                          isActive={true}
                                          onChange={(value) => {
                                              if (onChange) {
                                                  onChange(value, item.column_name);
                                              }
                                          }}
                                        />
                                      )}

                                      {item.type === 'text' && (
                                        <SPRichTextField
                                          defaultValue={allValue[`${item?.column_name}`]}
                                          isActive={true}
                                          onChange={(value) => {
                                              if (onChange) {
                                                  onChange(value, item.column_name);
                                              }
                                          }}
                                        />
                                      )}

                                      {item.type === 'boolean' && (
                                        <SPBooleanField
                                          defaultValue={allValue[`${item?.column_name}`]}
                                          isActive={true}
                                          onChange={(value) => {
                                              if (onChange) {
                                                  onChange(value, item.column_name);
                                              }
                                          }}
                                        />
                                      )}
                                      {item.type === 'float' && (
                                        <SPNumberField
                                          defaultValue={allValue[`${item?.column_name}`]}
                                          isActive={true}
                                          onChange={(value) => {
                                              if (onChange) {
                                                  onChange(value, item.column_name);
                                              }
                                          }}
                                        />
                                      )}
                                    {item.type === 'driver' && (
                                        <CustomFieldSPSelectField
                                          onChange={(value) => {
                                            if (onChange) {
                                              onChange(value.id, `${item.column_name}`);
                                            }
                                          }}
                                          schema={enumItems.user}
                                          defaultValue={allValue[`${item?.column_name}`]}
                                          forcedValue={undefined}
                                          disabled={false}
                                          isMissing={false}
                                          accordingToValue={undefined}
                                        />
                                      )}
                                  </Stack>

                              </Stack>
                          </>
                        );
                    })}
                </Stack>
            </>
          )}
      </>
    );
};

FullWidthCustomFields.includes = (query, value) => true;

FullWidthCustomFields.comparator = () => 0;

FullWidthCustomFields.FilterRenderer = TimeFilter;
